<template>
  <div v-if="!loading">
    <template v-if="template && mustUseTemplate">
      <v-alert type="info">
        You're required to use the <strong>{{ template.name }}</strong> template when sharing
        <strong>{{ presentation.name }}</strong>.
      </v-alert>
      <v-btn @click.prevent="selectTemplate(template)"
             color="primary">
        Continue
      </v-btn>
    </template>
    <v-card v-else-if="team.free_text_email_enabled"
            class="mb-4">
      <div class="pa-4">
        <v-radio-group v-model="useTemplate"
                       label="Do you want to use a template?"
                       class="ma-0 pa-0"
                       hide-details>
          <v-radio label="Yes, I want to select a template"
                   :value="true">
          </v-radio>
          <v-radio label="No, I will write the email from scratch"
                   :value="false"
                   @click="skipTemplate">
          </v-radio>
        </v-radio-group>
      </div>
    </v-card>

    <v-card v-if="useTemplate && !mustUseTemplate"
            class="mb-4">
      <v-card-title class="mb-0 pb-0">
        Step 1: Which email template do you want to use?
      </v-card-title>
      <template-picker :form="form"
                       :templates="filteredTemplates"
                       @selected="selectTemplate">
      </template-picker>
    </v-card>

    <div id="preview_template"></div>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import formValidation from '../../../plugins/formValidation';
import {Form} from 'vform';
import {isInteger, isNull} from 'lodash';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import TemplatePicker from '../components/TemplatePicker';
import presentationService from '../../../../../ml/services/presentationService';
import DOMPurify from 'dompurify';

export default {
  name: 'email-wizard-template',
  components: {TemplatePicker},
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        template_id: null,
      }),
      loading: false,
      presentation: null,
      template: null,
      templates: [],
      useTemplate: null,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    ...mapGetters('emailCart', [
      'cart',
    ]),
    areThereTemplatesInFolders() { // MLD-3276
      const templatesInFolders = this.templates.filter(t => !isNull(t.folder_id));
      return templatesInFolders.length > 0;
    },
    mustUseTemplate() {
      return this.presentation
        && this.presentation.share_template_id
        && this.presentation.is_template_required; // MLD-3997 this is a new requirement
    },
    filteredTemplates() {
      return this.templates.filter(template => { // MLD-2290
        return template.is_app || template.is_web;
      });
    },
    presentationID() {
      const presentationID = parseInt(this.$route.query.presentationID);
      if (isInteger(presentationID)) {
        return presentationID;
      }
      return null;
    },
    templateID() { // MLD-3464 - pass the template ID in as a URL parameter.
      const templateID = parseInt(this.$route.query.template_id);
      if (isInteger(templateID)) {
        return templateID;
      }
      return null;
    }
  },
  created() {
    // MLD-2797 require the user to select a template.
    this.useTemplate = !this.team.free_text_email_enabled; // MLD-2797
    this.$store.dispatch('content/updateActiveFolders', null); // MLD-3276 reset to the Home folder when sending an email.
    this.fetchData();
  },
  methods: {
    selectTemplate(template) {
      this.template = template;
      this.form.template_id = template.id;
      this.submit();
    },
    async fetchData() {
      try {
        this.loading = true;
        this.presentation = null;
        const params = { // MLD-4653
          can_be_selected: true,
        }
        this.templates = await shareTemplateService.getTemplatesForUser(params)
        if (this.presentationID) {
          this.presentation = await presentationService.getPresentation(this.presentationID);
          if (this.presentation && this.presentation.share_template_id) {
            this.useTemplate = true;
            this.form.template_id = this.presentation.share_template_id;
            this.template = await shareTemplateService.getTemplate(this.presentation.share_template_id);
          }
        } else if (this.cart.template) {
          this.useTemplate = true;
          this.form.template_id = this.cart.template.id;
          this.template = await shareTemplateService.getTemplate(this.form.template_id);
        } else if (this.templateID) { // MLD-3464 if the template ID was passed in as a URL parameter, try to select it.
          try {
            this.useTemplate = true;
            this.template = await shareTemplateService.getTemplate(this.templateID);
            this.form.template_id = this.templateID;
            this.submit();
          } catch (e) {
            this.useTemplate = true;
            this.form.template_id = null;
            this.$toast.error(`You do not have access to template ID ${DOMPurify.sanitize(this.templateID)}`);
          }
        }
      } finally {
        this.loading = false;
      }
    },
    skipTemplate() {
      this.form.template_id = null;
      this.template = null;
      this.submit();
    },
    submit() {
      //this.template = find(this.templates, t => t.id === this.form.template_id);
      this.$store.dispatch('emailCart/setTemplate', this.template);
      this.$store.dispatch('emailCart/nextStep');
      this.$router.push({name: `${this.$root.routePrefix}.email.wizard.recipient`, query: this.$route.query});
    }
  }
}
</script>
<style lang="scss"
       scoped>
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video,
.embed-responsive .framecover, {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.framecover {
  z-index: 99999;
}
</style>
